import { DotsCircleIcon } from './DotsCircleIcon';

/**
 * author: Michael Irigoyen
 * id FDC05366-F73E-4D60-B048-8AA4732B2C1F
 * name dots-circle
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-circle.svg
 * tags
 */
export const PerimeterIcon = DotsCircleIcon;
export default PerimeterIcon